import * as React from "react";
import { TaskListWrapper } from "src/components/TaskListPanel/TaskList/TaskList.components";
import TaskListItem from "src/components/TaskListPanel/TaskList/TaskListItem/TaskListItem";
import NewTaskPanel from "src/components/TaskListPanel/TaskList/NewTaskPanel/NewTaskPanel";
import { useGameContext } from "src/game/useGameContext";

export interface Props {
  onToggleNewTaskPanel: (value: boolean) => void;
  isAddingTask: boolean;
  taskListEndRef: React.RefObject<HTMLDivElement>;
}

const TaskList: React.FunctionComponent<Props> = ({
  onToggleNewTaskPanel,
  isAddingTask,
  taskListEndRef,
}) => {
  const { gameState } = useGameContext();

  const [taskToDelete, setTaskToDelete] = React.useState<string | null>(null);
  const [taskToEdit, setTaskToEdit] = React.useState<string | null>(null);

  return (
    <TaskListWrapper>
      {gameState.game?.allTasks?.map(task => (
        <TaskListItem
          key={task.id}
          taskId={task.id}
          title={task.description}
          finalResult={task.summary?.finalResult ?? null}
          isDeletingTask={taskToDelete === task.id}
          isEditingTask={taskToEdit === task.id}
          toggleDeleteConfirmPanel={(isDeleting: boolean, taskKey?: string) =>
            setTaskToDelete(isDeleting && taskKey ? taskKey : null)
          }
          toggleEditPanel={(isEditing: boolean, taskKey?: string) =>
            setTaskToEdit(isEditing && taskKey ? taskKey : null)
          }
        />
      ))}
      <NewTaskPanel
        isAddingTask={isAddingTask}
        onToggleNewTaskPanel={onToggleNewTaskPanel}
      />
      <div ref={taskListEndRef} />
    </TaskListWrapper>
  );
};

export default TaskList;
